/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_Preview_Lock_TitleInputs */

const en_player_preview_lock_title = /** @type {(inputs: Player_Preview_Lock_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preview CC`)
};

const fr_player_preview_lock_title = /** @type {(inputs: Player_Preview_Lock_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apercu des CC`)
};

const de_player_preview_lock_title = /** @type {(inputs: Player_Preview_Lock_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorschau CC`)
};

const it_player_preview_lock_title = /** @type {(inputs: Player_Preview_Lock_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anteprima CC`)
};

const ru_player_preview_lock_title = /** @type {(inputs: Player_Preview_Lock_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предварительный просмотр CC`)
};

const es_player_preview_lock_title = /** @type {(inputs: Player_Preview_Lock_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vista previa CC`)
};

const zh_cn2_player_preview_lock_title = /** @type {(inputs: Player_Preview_Lock_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`预览 CC`)
};

const ja_player_preview_lock_title = /** @type {(inputs: Player_Preview_Lock_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プレビューCC`)
};

const hi_player_preview_lock_title = /** @type {(inputs: Player_Preview_Lock_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पूर्वावलोकन सीसी`)
};

const pt_pt2_player_preview_lock_title = /** @type {(inputs: Player_Preview_Lock_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pré-visualização CC`)
};

/**
* | output |
* | --- |
* | "Preview CC" |
*
* @param {Player_Preview_Lock_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const player_preview_lock_title = /** @type {((inputs?: Player_Preview_Lock_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_Preview_Lock_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_player_preview_lock_title(inputs)
	if (locale === "de") return de_player_preview_lock_title(inputs)
	if (locale === "it") return it_player_preview_lock_title(inputs)
	if (locale === "ru") return ru_player_preview_lock_title(inputs)
	if (locale === "es") return es_player_preview_lock_title(inputs)
	if (locale === "zh-CN") return zh_cn2_player_preview_lock_title(inputs)
	if (locale === "ja") return ja_player_preview_lock_title(inputs)
	if (locale === "hi") return hi_player_preview_lock_title(inputs)
	if (locale === "pt-PT") return pt_pt2_player_preview_lock_title(inputs)
	return en_player_preview_lock_title(inputs)
});